// Discover's list sits in BrowseLayout: px-3 (24px), a 1rem gap, and a 380px
// featured column from the md breakpoint up. The scroll container's clientWidth
// already excludes the side nav and scrollbar gutters. The remaining 20px is the
// discover panel border plus the scrollbar inside that panel.
const PAGE_PADDING_PX = 24;
const COLUMN_GAP_PX = 16;
const FEATURED_COLUMN_PX = 380;
const PANEL_CHROME_PX = 20;
export const DISCOVER_LIST_CHROME_PX = PAGE_PADDING_PX + COLUMN_GAP_PX + FEATURED_COLUMN_PX + PANEL_CHROME_PX;

export function measureDiscoverListColumnWidth(): number | null {
    if (typeof window === 'undefined' || window.innerWidth < 768) return null;

    const scroll = document.getElementById('app-scroll-container');
    const contentWidth = scroll?.clientWidth
        ?? Math.max(0, window.innerWidth - (window.innerWidth >= 1024 ? 100 : 0));

    return Math.max(280, contentWidth - DISCOVER_LIST_CHROME_PX);
}
